<h1 mat-dialog-title>Crop Thumbnail</h1>
<div class="content" mat-dialog-content>
    <div class="root">
        <img #image [src]="data.image" />
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-stroked-button color="primary" (click)="save()">Save</button>
</div>
